import { ResizableBox } from "react-resizable"
import { useProject } from "../../components/Providers"
import "react-resizable/css/styles.css"
import style from "./controlPanel.module.scss"
// import ControlPanelCurrent from "./ControlPanelCurrent"
// import ControlPanelInfo from "./ControlPanelInfo"
// import ControlPanelOptions from "./ControlPanelOptions"
import ControlPanelTexts from "./ControlPanelTexts"
import ControlPanelBmp from "./ControlPanelBmp"
import ControlPanelSend from "./ControlPanelSend"
import ControlPanelBus from "./ControlPanelBus"

const ControlPanel = (menu) => {
	//const { project } = useProject()
	const {innerWidth, innerHeight} = window;
	var barwid = innerWidth/3;
	if(menu.menu == "text") barwid = innerWidth*3/5-150;
	if(barwid > 600) barwid = 600;
	else if(barwid < 300) barwid = 300;
	// if(menu.menu == "image") barwid = 500;
	// else if(menu.menu == "send") barwid = 500;
	return (
		<ResizableBox
			width={barwid}
			height={Infinity}
			minConstraints={[160, Infinity]}
			maxConstraints={[1300, Infinity]}
			axis='x'
			resizeHandles={["w"]}
			className={style.controlPanelResizable}
			handle={
				<div className={style.handleBox}>
					<div />
					<div />
				</div>
			}
			handleSize={[10, Infinity]}
		>
			<div className={style.controlPanel}>
				{menu.menu == "text" && 	<ControlPanelTexts />}
				{menu.menu == "image" && 	<ControlPanelBmp />}
				{menu.menu == "send" && 	<ControlPanelSend />}
				{menu.menu == "bus" && 	<ControlPanelBus />}
			</div>
		</ResizableBox>
	)
}

export default ControlPanel
